export const sidebarVariants = {
  closed: {
    transition: {
      duration: 0.2,
    },
    width: "60px",
  },
  open: {
    transition: {
      duration: 0.2,
    },
    width: "200px",
  },
};



// WEBPACK FOOTER //
// ./src/shared/components/sidebar/Sidebar.variants.ts